<article>
	<header class="page-header">
		<div class="breadcrumb-line">
			<stages-breadcrumb [links]="true" [path]="breadcrumb"></stages-breadcrumb>
			<stages-process-version
				*ngIf="self"
				[type]="self.type?.ident"
				[identity]="self.identity"
			></stages-process-version>
		</div>
		<stages-element-name [self]="$any(self)"></stages-element-name>
	</header>

	<div class="container row">
		<div class="container column col-12">
			<ng-container stagesSlot="top"></ng-container>
		</div>
	</div>
</article>

<div id="right-navigation" *ngIf="type?.toolbar">
	<nav>
		<ul class="toolbar">
			<li>
				<stages-menu
					[menuId]="'menu_' + self?.id"
					[items]="menuItems"
					[context]="{ type: self?.type?.ident, id: self?.id, parentId: self?.parent?.id }"
					hasItemIcon="true"
					iconClasses="ico ico-more-vertical"
					openTo="left"
					[noCollapse]="true"
				>
				</stages-menu>
			</li>
			<li *ngFor="let perspective of perspectives" [ngClass]="{ active: isPerspectiveActive(perspective.ident) }">
				<a
					role="button"
					[attr.title]="'perspective.' + perspective.ident | translate"
					[attr.aria-label]="'perspective.' + perspective.ident | translate"
					class="clickable"
					(click)="openPerspective(perspective.ident)"
				>
					<i class="ico ico-{{ perspective.ident }}"></i>
					<i *ngIf="perspective.changeMarker" class="ico ico-exclamation-mark change-marker"></i>
				</a>
			</li>
		</ul>
	</nav>
</div>
